/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_Subtitle_Export_Completed_SuccessfullyInputs */

const en_batch_subtitle_export_completed_successfully = /** @type {(inputs: Batch_Subtitle_Export_Completed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batch export completed successfully`)
};

const fr_batch_subtitle_export_completed_successfully = /** @type {(inputs: Batch_Subtitle_Export_Completed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation par lot terminée avec succès`)
};

const de_batch_subtitle_export_completed_successfully = /** @type {(inputs: Batch_Subtitle_Export_Completed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batch-Export erfolgreich abgeschlossen`)
};

const it_batch_subtitle_export_completed_successfully = /** @type {(inputs: Batch_Subtitle_Export_Completed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione batch completata con successo`)
};

const ru_batch_subtitle_export_completed_successfully = /** @type {(inputs: Batch_Subtitle_Export_Completed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пакетный экспорт успешно завершен.`)
};

const es_batch_subtitle_export_completed_successfully = /** @type {(inputs: Batch_Subtitle_Export_Completed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La exportación por lotes se completó correctamente`)
};

const zh_cn2_batch_subtitle_export_completed_successfully = /** @type {(inputs: Batch_Subtitle_Export_Completed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`批量导出已成功完成`)
};

const ja_batch_subtitle_export_completed_successfully = /** @type {(inputs: Batch_Subtitle_Export_Completed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バッチエクスポートが正常に完了しました`)
};

const hi_batch_subtitle_export_completed_successfully = /** @type {(inputs: Batch_Subtitle_Export_Completed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बैच निर्यात सफलतापूर्वक पूरा हुआ`)
};

const pt_pt2_batch_subtitle_export_completed_successfully = /** @type {(inputs: Batch_Subtitle_Export_Completed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportação em lote concluída com sucesso.`)
};

/**
* | output |
* | --- |
* | "Batch export completed successfully" |
*
* @param {Batch_Subtitle_Export_Completed_SuccessfullyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_subtitle_export_completed_successfully = /** @type {((inputs?: Batch_Subtitle_Export_Completed_SuccessfullyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_Subtitle_Export_Completed_SuccessfullyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_batch_subtitle_export_completed_successfully(inputs)
	if (locale === "de") return de_batch_subtitle_export_completed_successfully(inputs)
	if (locale === "it") return it_batch_subtitle_export_completed_successfully(inputs)
	if (locale === "ru") return ru_batch_subtitle_export_completed_successfully(inputs)
	if (locale === "es") return es_batch_subtitle_export_completed_successfully(inputs)
	if (locale === "zh-CN") return zh_cn2_batch_subtitle_export_completed_successfully(inputs)
	if (locale === "ja") return ja_batch_subtitle_export_completed_successfully(inputs)
	if (locale === "hi") return hi_batch_subtitle_export_completed_successfully(inputs)
	if (locale === "pt-PT") return pt_pt2_batch_subtitle_export_completed_successfully(inputs)
	return en_batch_subtitle_export_completed_successfully(inputs)
});